export default __webpack_public_path__ + "static/media/infra-23.d95beb29.webp";